import { getDashboardAnalytics } from '@api/database-logs/api';
import { ActionChartData, AnalyticsRecord, FieldChartData, HeatMapData, KPIData, TrendData } from '@pages/datalogs-secondary-analysis/types';
import { normalizeAnalyticsData, buildKPIData, buildTrendData, buildFieldChart, buildActionChart, buildHeatMapData, buildSummary, buildDistributionData } from '@pages/datalogs-secondary-analysis/utils';
import { useEffect, useMemo, useState } from 'react';

// or import { getLogsData } from '../services/...';



export interface DashboardFilters {
  field: string;
  action: string;
  period: 'week' | 'month'
}

const ALL = 'All';

export const useAnalytics = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [records, setRecords] = useState<AnalyticsRecord[]>([]);
    const [fieldName, setFieldName] = useState<AnalyticsRecord[]>([]);

  const [filters, setFilters] = useState<DashboardFilters>({
    field: ALL,
    action: ALL,
    period:'week',
  });

  const loadDashboard = () => {
    setLoading(true);

    getDashboardAnalytics().subscribe({
  next: response => {
    setRecords(normalizeAnalyticsData(response));
    setLoading(false);
  },
      error: err => {
        setLoading(false);
        setError(err?.message || 'Something went wrong');
      },
    });
  };

  useEffect(() => {
    loadDashboard();
  }, [filters]);

  const filteredRecords = useMemo(() => {
    return records.filter(record => {
      const fieldMatch =
        filters.field === ALL ||
        record.fieldName === filters.field;

      const actionMatch =
        filters.action === ALL ||
        record.action === filters.action;

      return fieldMatch && actionMatch;
    });
  }, [records, filters]);

  const kpiData = useMemo(
    () => buildKPIData(filteredRecords),
    [filteredRecords]
  );

  const trendData = useMemo(
    () => buildTrendData(filteredRecords),
    [filteredRecords]
  );

  const fieldChartData = useMemo(
    () => buildFieldChart(filteredRecords, filters.period),
    [filteredRecords,filters.period]
  );

  const heatMapData = useMemo(
    () => buildHeatMapData(filteredRecords),
    [filteredRecords]
  );
  
const actionChartData = useMemo(
  () => buildActionChart(filteredRecords, filters.period),
  [filteredRecords, filters.period]
);

  /**
   * Summary Table
   */

  const summaryData = useMemo(
    () =>
      buildSummary(filteredRecords),
    [filteredRecords]
  );

  const distributionData = useMemo(
  () => buildDistributionData(filteredRecords, filters.period),
  [filteredRecords, filters.period]
);

  return {
    loading,
    error,

    records,

    filters,
    setFilters,

    kpiData,
    trendData,
    fieldChartData,
    actionChartData,
    heatMapData,
    summaryData,
    distributionData,
    refresh: loadDashboard,
  };
};